export default __webpack_public_path__ + "static/media/36I-114288_-20997_0.85bee0c7.jpg";